<template>

  <div class="filterbox">

      <el-date-picker v-if="fieldobj.type == 'daterange'" v-model="filterval" type="daterange" value-format="yyyy-MM-dd"
        align="right" unlink-panels range-separator="到" start-placeholder="开始" end-placeholder="结束"></el-date-picker>

      <input v-else-if="fieldobj.type == 'numberrange'" v-model="filterval" @keyup.enter="tosearch">

      <input v-else v-model="filterval" @keyup.enter="tosearch" autocomplete="off" :clearable="true">

      <label :class="filterval ? 'labeldefault labelsit' : 'labeldefault '">{{ fieldobj.title+(fieldobj.type == 'numberrange'?' 输入取值范围，格式如：2 10':"") }}</label>

  </div>

</template>

<script>

export default {
  props: ["fieldobj"],

  mounted() {

  },
  data() {
    return {
      filterval: this.$store.state.filter[this.fieldobj.name]
    }
  },
  watch: {
    filterval(val, oldval) {
      this.$store.commit("setfilterbyval", { key: this.fieldobj.name, val: val })
      this.$store.commit("settargettxt", JSON.stringify(this.$store.state.filter))
    }

  },
  computed: {

  },
  methods: {
    tosearch() {
      this.$axios.fetchdata()
      this.$store.commit("setsearchmodel", "generalsearch")
      this.$store.commit("setpage", 1);
      this.$axios.fetchdata();
      this.$emit("filterdone")
    }

  }
};
</script>

<style>
.filterbox {
  /* padding:10px 0 10px 0; */
  background: rgba(220, 205, 205, 0.5);
  border-radius: 5px;
  padding: 0.7rem 0 0.7rem 0;
  margin-bottom: 0;

}

.filterbox  {
  position: relative;
}

.filterbox input {
  width: 90%;
  /* padding: 10px 0; */
  /* font-size: 15px; */
  color: #211d1d;
  /* margin-bottom: 30px; */
  border: none;
  border-bottom: 1px solid #fff;
  outline: none;
  background: transparent;
  transition: .3s;
}

.filterbox input:hover{
  width:100%;
  /* font-size: 16px; */
  /* height:3em; */
  border-bottom: 2px solid #961717;
}
.filterbox input:hover ~ label{
  color:#961717
}

 /* .filterbox  label  */
 .labeldefault{
  position: absolute;
  top: 0;
  left: 2px;
  font-size: 16px;
  color: #554c8e;
  pointer-events: none;
  transition: .2s;
}

.filterbox input:focus ~ label
{
  top: -10px;
  left: 0;
  color: #1225f3;
  font-size: 10px;
}

.labelsit {
  top: -10px;
  left: 0;
  color: #1225f3;
  font-size: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/presentation/table/filterbox_filter_field.vue